import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconCheck, IconCopy } from '@redteclab/icons'

import { useCopyText } from '../../generic-hooks'

export const StickyBannerVoucherCopy: FC<{ voucher: string }> = ({
  voucher,
}) => {
  const intl = useIntl()
  const { copied, copyText } = useCopyText(voucher)

  return (
    <div className="flex flex-row items-center rounded-md bg-light-primary-low px-5 py-2">
      <div className="flex flex-col pr-2 text-m">
        <span className="text-xs text-dark-primary-strong">
          <FormattedMessage id="general.label.voucherCode" />
        </span>
        <span className={clsx(copied && 'text-dark-success')}>
          {copied ? (
            <FormattedMessage id="stickyBanner.coutdown.copied" />
          ) : (
            voucher
          )}
        </span>
      </div>
      {copied ? (
        <IconCheck className="text-3xl text-dark-success" />
      ) : (
        <button
          aria-label={intl.formatMessage({ id: 'general.label.copy' })}
          onClick={() => {
            void copyText()
          }}
          type="button"
        >
          <IconCopy className="text-3xl text-dark-info-strong" />
        </button>
      )}
    </div>
  )
}
